module.exports = __webpack_public_path__ + "media/Momento.645f9160.mp4";